import { render, staticRenderFns } from "./buyerRechercheModule.vue?vue&type=template&id=68f65af5"
import script from "./buyerRechercheModule.vue?vue&type=script&lang=js"
export * from "./buyerRechercheModule.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./buyerRechercheModule.vue?vue&type=style&index=0&id=68f65af5&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports